"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardPhotoHeader = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardPhotoHeaderMixin = require("../../mixins/components/PropertyCardPhotoHeaderMixin");
var StyledPropertyCardPhotoHeader = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledPropertyCardPhotoHeader",
  componentId: "c11n-8-107-0__sc-4wdzry-0"
})(["", ""], _PropertyCardPhotoHeaderMixin.PropertyCardPhotoHeaderMixin);
exports.StyledPropertyCardPhotoHeader = StyledPropertyCardPhotoHeader;